<template>
<div class="portada">
  <v-layout class="bg animated slideInUp" fill-height wrap align-center justify-center>
    <v-flex text-xs-center>
      <img class="logo animated fadeIn dura-1" src="../assets/logo.png" alt="Ecopetrol">
      <h1>
        <span class="animated fadeIn dura-2 pre">Bienvenido al curso</span><br><span class="animated fadeIn dura-3">El ABC de las Reservas y<br>los Recursos de Hidrocarburos</span>
      </h1>
      <router-link to="/modulos" class="inicio-boton animated bounceIn dura-4">Inicio</router-link>
    </v-flex>
  </v-layout>
  <audio-player ref="audioPlayer" :autoplay="true" :audios="[
  'Presentacion/AUDIO 01'
  ]"></audio-player> 
</div>
</template>
<script>
export default {
  mounted() {
    // Cargar imágenes de los módulos
    var paths = []
    paths.push(require('../assets/grass.png'));
    paths.push(require('../assets/ground.png'));
    paths.push(require('../assets/svg.svg'));
    paths.push(require('../assets/snow.png'));
    paths.push(require('../assets/rock.png'));
    paths.forEach(path => {
      var img = new Image()
      img.src = path
    });
  }
}
</script>
<style lang="scss" scoped>
.portada {
  position: absolute;
  top:0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/gradient-bg.jpg');
  background-size: 100% 100%;
  .bg {
    background-image: url('../assets/background.png');
    background-position: center calc(100%);
    border-bottom: 20px solid #343516;
    @media (max-width: 600px) {
      background-size: auto 15vh;
      background-position-x: 30%;
    }
  }

  .logo {
    background-color: white;
    padding: 10px;
    max-width: 300px;
  }

  h1 {
    font-size: 43pt;
    line-height: 51pt;
    font-family: helveticaNeueCn;
    .pre {
      font-size: 33pt;
      font-family: helveticaNeueCn;
      font-weight: lighter;
    }

    @media (max-width: 1024px) {
      font-size: 3rem;
      line-height: 3rem;
      span {
        font-size: 2.5rem;
      }
    }
  }

  .inicio-boton {
    margin-top: 15pt;
    display: inline-block;
    background-image: url('../assets/imagenes_compartidas/fondo-boton.png');
    background-size: contain;
    background-position: center;
    border-radius: 100%;
    width: 8rem;
    height: 8rem;
    color: black;
    font-family: helveticaNeueCn;
    font-weight: bold;
    font-size: 25pt;
    text-transform: uppercase;
    text-decoration: none;
    padding-top: 1.5em;
    padding-left: 3px;
    border-radius: 100%;
    transition: all 100ms linear;
    @media (max-width: 1024px) {
      width: 8rem;
      height: 8rem;
      padding-top: 2.5rem;
      font-size: 2.2rem;
    }
    &:hover {
      box-shadow: 0 5px 10px black;
      transform: scale(1.05);
    }
    &:active {
      box-shadow: 0 0 0 transparent;
      transform: scale(1);
    }
  }
}
</style>